import { useEffect } from 'react'
import { Box, Text, Title } from '@holbonkit/ui'
import { Controller, useForm } from 'react-hook-form'

import { MaskedInput } from '@/shared/ui'

import type { TStepFormProps } from '../../lib/step-form-props'

import { SbpBottomSheet } from './sbp-bottom-sheet'
import type { TSbpForm } from './types'
import { sbpValidator } from './validator'

import styles from './sbp.module.scss'

export const SBP_FORM_ID = 'smz-sbp-form'

const EMPTY_SBP: TSbpForm = {
    bank: '',
    number: '',
}

type TSbpProps = TStepFormProps<TSbpForm>

export const Sbp = ({ defaultValues, formId, onSubmit, onValidityChange }: TSbpProps) => {
    const {
        control,
        handleSubmit,
        reset,
        clearErrors,
        formState: { isValid },
    } = useForm<TSbpForm>({
        defaultValues: EMPTY_SBP,
        mode: 'onTouched',
        reValidateMode: 'onChange',
    })

    useEffect(() => {
        reset(defaultValues ?? EMPTY_SBP)
    }, [defaultValues, reset])

    useEffect(() => {
        onValidityChange?.(isValid)
    }, [isValid, onValidityChange])

    return (
        <form noValidate id={formId} onSubmit={handleSubmit(onSubmit)}>
            <Box className={styles['sbp']} pt={6} px={4}>
                <Title variant='header-24-bold'>Личные данные</Title>
                <Controller
                    control={control}
                    name='number'
                    rules={sbpValidator.phone}
                    render={({ field, fieldState }) => (
                        <MaskedInput
                            data-test-id='sbp__phone'
                            errorText={fieldState.error?.message}
                            label='Номер телефона'
                            name={field.name}
                            preset='phoneNumber'
                            value={field.value}
                            onBlur={field.onBlur}
                            onChange={field.onChange}
                            onFocus={() => {
                                clearErrors('number')
                            }}
                        />
                    )}
                />
                <Text className={styles['sbp__description']} variant='body-s-14-regular'>
                    Укажите свой номер. Анкета не пройдёт проверку, если номер привязан к чужому
                    счёту СБП
                </Text>

                <SbpBottomSheet />
            </Box>
        </form>
    )
}
